var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-processing"},[_c('div',{staticClass:"video-processing__icon"},[_c('ProcessningIcon',{staticClass:"video-processing__img"})],1),_vm._v(" "),_c('div',{staticClass:"video-processing__title"},[_vm._v("\n    The video will be available in a few seconds once we complete the processing.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }